import { FlexBox } from '../../../components/Base/Base'
import { isConsole } from '../../../config/config'
import { HandlerOf } from '../../../helpers/typeHelper'
import { Job, JobStatus } from '../../../models/job'
import { User } from '../../../models/user'
import { ProfileJobsSection } from './ProfileJobsSection'

interface ProfileJobsProps {
  user: User
  handleJobOpen: HandlerOf<Job>
  jobUrlConstructor?: (job: Job) => string | undefined
  isInsideSidebar?: boolean
  hasJobListRedesignFlag?: boolean
}

export enum ProfileJobOrderBy {
  PICK_UP_DATE = 'PICK_UP_DATE',
  DROPOFF_DATE = 'DROPOFF_DATE',
  STATUS = 'STATUS',
  BROKER = 'BROKER',
  DATE_LAST_MODIFIED = 'DATE_LAST_MODIFIED',
}

export const profileJobOrderByLabels = {
  [ProfileJobOrderBy.PICK_UP_DATE]: 'Pickup date',
  [ProfileJobOrderBy.DROPOFF_DATE]: 'Dropoff date',
  [ProfileJobOrderBy.STATUS]: 'Status',
  [ProfileJobOrderBy.BROKER]: 'Broker',
  [ProfileJobOrderBy.DATE_LAST_MODIFIED]: 'Date last modified',
}

export const ProfileJobOrderByAscDescSort = [
  ProfileJobOrderBy.PICK_UP_DATE,
  ProfileJobOrderBy.DROPOFF_DATE,
  ProfileJobOrderBy.DATE_LAST_MODIFIED,
]
export type ProfileJobOrderByDirection = '-' | ''

export function ProfileJobs(props: ProfileJobsProps) {
  const isSplitList = isConsole() && props.hasJobListRedesignFlag

  if (isSplitList) {
    return (
      <FlexBox isColumn>
        <ProfileJobsSection {...props} splitStatus={JobStatus.PENDING} />
        <ProfileJobsSection {...props} splitStatus={JobStatus.FUTURE} />
        <ProfileJobsSection {...props} splitStatus={JobStatus.CURRENT} />
        <ProfileJobsSection {...props} splitStatus={JobStatus.PAST} />
      </FlexBox>
    )
  }

  return <ProfileJobsSection {...props} />
}
